import { render, staticRenderFns } from "./rdsmslog-add-or-update.vue?vue&type=template&id=15af9d14&"
import script from "./rdsmslog-add-or-update.vue?vue&type=script&lang=js&"
export * from "./rdsmslog-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports